type RouteType = ((__redirectData: string) => string) | string;

const redirectIdToRouteMapper: Record<string, RouteType> = {
  '1': '/',
  '2': (redirectData) => cleanExternalUrl(redirectData),
  '3': '/withdraw',
  '4': '/transactions',
  '5': '/card/deposit',
  '6': '/deposit',
  '7': (redirectData) => `/stock/${redirectData}`,
  '8': (redirectData) => `/invest/fund/${redirectData}`,
  '9': '/pfm',
  '10': '/profile',
  '12': '/?index=1',
  '13': '/invest/robo-advisor/risk-assessment',
  '14': (redirectData) =>
    `/invest/fund/transaction/${redirectData && '?fundCode=' + redirectData}`,
  '15': '/card/transfer',
  '16': (redirectData) =>
    redirectData ? `/auto-invest/schedules/${redirectData}` : '/auto-invest',
  '17': '/invest/investment-advisory',
  '18': '/auto-invest/hami-profit',
};

export const getRouteByData = (
  redirectId: string,
  redirectData?: string
): string => {
  if (Object.hasOwn(redirectIdToRouteMapper, redirectId)) {
    const route = redirectIdToRouteMapper[redirectId];
    if (typeof route === 'function') {
      return route(redirectData ?? '');
    }
    return route as string;
  }
  return '/';
};

// Check to see if url is an external url or internal url
const cleanExternalUrl = (url: string) => {
  const baseUrl = 'https://my.emofid.com';

  // Check if the URL starts with the base URL
  if (url.startsWith(baseUrl)) {
    // Remove the base URL from the start
    url = url.replace(baseUrl, '');
  } else {
    // If not, return the original URL
    return url;
  }

  // Create a URL object to easily work with query parameters
  const urlObj = new URL(url, baseUrl);

  // Default query params that need to get removed in web
  const removeParams = ['utm_campaign', 'utm_medium', 'utm_source'];

  // Remove the specified query parameters
  removeParams.forEach((param) => urlObj.searchParams.delete(param));

  const cleanedUrl = urlObj.pathname + (urlObj.search ? urlObj.search : '');

  return cleanedUrl || '/';
};
